<template>
  <div data-testid="ctSearchFiltersSkeleton">
    <SkeletonLoader
      v-if="showSearchBox"
      height="44px"
      class="mb-6"
    />
    <SkeletonLoader
      :height="CATEGORIES_HEIGHT"
      class="mb-6"
    />
    <SkeletonLoader
      v-for="filter in CT_SEARCH_FILTERS"
      :key="filter.name"
      :height="getFilterHeight(filter)"
      class="mb-6"
      :data-testid="`ctFilterSkeleton-${filter.name}`"
    />
  </div>
</template>

<script setup lang="ts">
import { CT_SEARCH_FILTERS, CT_SEARCH_FILTER_KIND } from '~~/constants/commercetoolsProductSearch';
import type { CtSearchFilterDefinition } from '~~/types/commercetools/productSearch';

// The filter sidebar of CtSearchContainer: one block per group, in the order of CT_SEARCH_FILTERS.
defineOptions({ name: 'CtSearchFiltersSkeleton' });

withDefaults(defineProps<{
  showSearchBox?: boolean;
}>(), {
  showSearchBox: false,
});

// Heights in px, measured on the loaded sidebar.
const CATEGORIES_HEIGHT = 400;
const TITLE_HEIGHT = 33;
const CONTENT_HEIGHTS: Record<CtSearchFilterDefinition['kind'], number> = {
  [CT_SEARCH_FILTER_KIND.REFINEMENT_LIST]: 78,
  [CT_SEARCH_FILTER_KIND.PRICE]: 60,
  [CT_SEARCH_FILTER_KIND.RATING]: 124,
};

const getFilterHeight = (filter: CtSearchFilterDefinition) =>
  CONTENT_HEIGHTS[filter.kind] + (filter.hideTitle ? 0 : TITLE_HEIGHT);
</script>
